import { Variant } from "../../../../Interfaces/Product";
import { IConfiguratorUpdater } from "../types";
import { ATTRIBUTES } from "../configuration";

export class Attributes implements IConfiguratorUpdater {
    private variant: Variant;

    constructor(private readonly node: HTMLElement) {
        this.node = node;
    }

    /**
     * update attributes
     * @param v
     */
    public update(v: Variant) {
        this.variant = v;
        Object.keys(ATTRIBUTES).forEach((key: keyof Variant) => this.updateAttribute(key));
    }

    /**
     * update a single attribute according to configuration
     * @param key
     * @private
     */
    private updateAttribute(key: keyof Variant) {
        ATTRIBUTES[key].elements.forEach((element) => {
            const node = document.querySelector<HTMLElement>(element.selector);
            let value = this.variant[key] as string | number;
            if (element.transform) {
                value = element.transform(value);
                // To hide compare_at_price if it's 0
                node.parentElement.classList.toggle("hide-me", value === "0");
            }
            if (element.dataset) {
                node.dataset[element.dataset] = String(value);
            } else {
                node.innerHTML = String(value);
            }
        });
    }
}
